import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { HierarchyListPathParameters } from 'api/actions/hierarchy-list/hierarchy-list-path-parameters';
import { HierarchyListResponse } from 'api/actions/hierarchy-list/hierarchy-list-response';

type HierarchyListQueryParameters = Record<string, any>;

/**
 * The path of the HierarchyList action.
 */
export const hierarchyListActionPath = new SweetPath<keyof HierarchyListPathParameters>('/api/hierarchy/list', {
  path: '{param}',
});

/**
 * Creates a contextualized HierarchyList actions.
 */
export default function createHierarchyListAction(axios: AxiosInstance) {
  return function hierarchyListAction({
    headers = {},
    query = {},
  }: { headers?: AxiosRequestConfig<any>['headers']; query?: HierarchyListQueryParameters } = {}) {
    const path = hierarchyListActionPath.original;

    return axios.request<HierarchyListResponse, HierarchyListResponse>({
      method: 'get',
      url: path,
      params: query,

      headers,
    });
  };
}
